$.fn.setInnerHeight = function() {
    $(this).each(function(i, item) {
        var section_parent = $(this);
        var section_iframe = $(section_parent).find('.section-content-object');
        var section_main = $(section_parent).find('.section-content-main');
        var section_main_height = $(section_main).outerHeight();
        $(section_iframe).css({'max-height': section_main_height});
    });
}

$.fn.strechtObjectHeight = function() {
    $(this).each(function(i, item) {
        $(item).removeAttr('style');
        var img_height = $(item).height();
        var div_height = $(item).parent().height();

        if(img_height<div_height){
            $(item).css({'width': 'auto', 'height': div_height });
            var img_width = $(item).width();
            var div_width = $(item).parent().width();
            var newMargin = (div_width-img_width)/2+'px';
            $(item).css({'margin-left': newMargin });
        }
        else{
            var newMargin = (div_height-img_height)/2+'px';
            $(item).css({'margin-top': newMargin});
        }
    });
};

$.fn.loadSectionImage = function() {
    var viewport_width = $(document).width();
    var pixel_ratio = window.devicePixelRatio;
    var element = $(this);
    var image_name = $(element).data('image');
    var element_width = $(element).width();
    var loading_complete = $(element).hasClass('loading-complete');
    if(!loading_complete) {
        $(element).addClass('is-loading');
        $.ajax({
            type: 'POST',
            url: js_vars.ajax_url,
            dataType: 'json',
            data: {
                action: 'perform_section_ajax',
                fn: 'get_image_src',
                image: image_name,
                viewport_width: viewport_width,
                pixel_ratio: pixel_ratio,
                element_width: element_width
            },
            success: function (data, textStatus, XMLHttpRequest) {
                if(data.adaptive_url!='') {
                    var css = 'url(' +data.adaptive_url +')';
                } else {
                    var css = 'url(' +data.small_url +')';
                }
                $(element).removeAttr('style');
                $(element).css({'background-image': css});
                $(element).removeClass('is-loading');
                $(element).addClass('loading-complete');
                $(element).data('loading-complete', true);

            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                $(element).removeClass('is-loading');
                $(element).addClass('error-loading');
            }
        });
    }
};


$(document).ready(function(){

    // Cover iFrames

    $('.section-style-inner').setInnerHeight();
    $('.section-option-autoscale').strechtObjectHeight();

    $(window).on('resize', function() {
        $('.section-style-inner').setInnerHeight();
        $('.section-option-autoscale').strechtObjectHeight();
    });

    // Trigger section visibilty
    $('.section-trigger-visibility').bind('inview', function(event, visible){
        if(visible) {
            $(this).addClass('is-visible');
        }
        else {
            $(this).removeClass('is-visible');
        }
    });

    // Lazy backgound images when section is in view
    $('.section-content-image').bind('inview', function(event, visible) {
        $(this).loadSectionImage();
    });

    $('.section-hero-image').loadSectionImage();



});


// slick slider events for header images
/*
$('.slick').ready(function() {
    // first run
    $('.section-slides').on('init', function(event, slick, direction){
        //console.log('slick carousel inits');
        $('.slick-current .section-slide').loadSectionImage();
    });
    // on change
    $('.section-slides').on('afterChange', function(event, slick, direction){
        //console.log('slick carousel changed');
        $('.slick-current .section-slide').loadSectionImage();
    });
});

*/